<div class="row">
  <div class="col-md-12 mt-2">
    <h4 class="text-left">
      <strong>
        Total de Custos e Recursos:
        {{ (totalEquipePlanejado + totalOutrosPlanejado + totalEquipeExecucao + totalOutrosExecucao) |
        currency:'BRL':'symbol-narrow':'1.2-2' }}
      </strong>
    </h4>

  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="card card-outline card-lightblue">
      <div class="card-header d-flex pb-0">
        <h3 class="card-title mb-0">
          Custos e Recursos Realizados - Planejamento
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <app-custos-equipe-list [secaoId]="1" [visualizar]="visualizar"
              (subtotalChange)="totalEquipePlanejado = $event"></app-custos-equipe-list>
          </div>
          <div class="col-md-12">
            <app-custos-recursos-outros-list [secaoId]="1" [visualizar]="visualizar"
              (subtotalChange)="totalOutrosPlanejado = $event"></app-custos-recursos-outros-list>
          </div>
          <div class="col-md-12 mt-2">
            <strong>
              Total dos Custos e Recursos Realizado – Planejamento:
              {{ (totalEquipePlanejado + totalOutrosPlanejado) | currency:'BRL':'symbol-narrow':'1.2-2' }}
            </strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="card card-outline card-lightblue">
      <div class="card-header d-flex pb-0">
        <h3 class="card-title mb-0">
          Custos e Recursos Previstos - Execução
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <app-custos-equipe-list [secaoId]="2" [visualizar]="visualizar"
              (subtotalChange)="totalEquipeExecucao = $event"></app-custos-equipe-list>
          </div>
          <div class="col-md-12">
            <app-custos-recursos-outros-list [secaoId]="2" [visualizar]="visualizar"
              (subtotalChange)="totalOutrosExecucao = $event"></app-custos-recursos-outros-list>
          </div>
          <div class="col-md-12 mt-2">
            <strong>
              Total dos Custos e Recursos Previstos – Execução:
              {{ (totalEquipeExecucao + totalOutrosExecucao) | currency:'BRL':'symbol-narrow':'1.2-2' }}
            </strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>